import { Dialog, DialogTitle, Divider, Grid, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer,
   TableHead, TablePagination, TableRow,ToggleButton , Typography, } from "@mui/material";
import React, { useState } from "react";
import { useEffect } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import BillingService from "../../../Services/MasterBilling/BillingService";
import DeleteOutlineRoundedIcon from '@mui/icons-material/DeleteOutlineRounded';
import Home from "../../home/Home";
import Snacbar from "../../Snacbar";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { useNavigate } from "react-router";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: 'rgb(61, 195, 177)',
    color: theme.palette.common.black,
      textAlign: "center",
      padding: theme.spacing(0.5),
      fontFamily: 'Times New Roman',
      fontWeight: 'bold',
  },
  [`&.${tableCellClasses.body}`]: {
    textAlign: "center",
    fontSize: 14,
    fontFamily: 'Times New Roman',
  },
}));
const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
}));
const ItemPap = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  // border: " 1px solid black",
  // backgroundColor: "#C8EDE7",
  height: "100%",
}));
const ItemPap1 = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(1),
  textAlign: "center",
  color: theme.palette.text.secondary,
  backgroundColor: "white",
  height: "100%",
}));

function Itemtype() {
  const mystyle = {
    border: " 1px solid black",
    width: "12rem",fontFamily: 'Times New Roman',
  };
  const mystyle1 = {
    fontWeight: "bolder",
    color: "red",fontFamily: 'Times New Roman',
  };
  const [open, setOpen] = useState(false);
  const [severity, setSeverity] = useState('');
  const [message, setMessage] = useState('');

  const [values, setitem] = useState({
    itemcode: '',
    itemname: '',
    itemId: '',
  });
  const [error, setError] = useState({
    itemcode: false,
    itemname: false,
  })
  const [Itemdetails, setItemdetails] = useState([]);

  const [itemTypeSaveDsa, setItemTypeSaveDsa] = useState(false);
  const [itemTypeUpdateDsa, setItemTypeUpdateDsa] = useState(true);
  const [itemTypeDeleteDsa, setItemTypeDeleteDsa] = useState(true);
  const [itemTypeSave, setItemTypeSave] = useState(false);
  const [itemTypeUpdate, setItemTypeUpdate] = useState(false);
  const [itemTypeDelete, setItemTypeDelete] = useState(false);

  const itemcodehandlechange = (e) => {
    setitem({ ...values, itemcode: e.target.value });
  };
  const itemnamehandlechange = (e) => {
    setitem({ ...values, itemname: e.target.value });
  };

  //getData
  const getData = async () => {
    BillingService.getItem().then((res) => {
      setItemdetails(res.data);
    })
  }

  useEffect(() => {
    getData();
  }, []);

  //tableClick

  const editItemDetails = (item) => {
    setItemTypeSaveDsa(true); setItemTypeUpdateDsa(false); setItemTypeDeleteDsa(false);
    setItemTypeSave(false); setItemTypeUpdate(false); setItemTypeDelete(false);
    setitem({ ...values, itemcode: item.itemCode, itemname: item.itemName, itemId: item.itemID });
    setError({ ...error, itemcode: false, itemname: false })
  }

  //clickHandleEvente

  const validate = () => {
    if (values.itemcode !== '') {
      if (values.itemname !== '') {
        return true;
      } else {
        setitem({ ...values, itemname: '' })
        document.getElementById('ItemName').focus();
        setError({ ...error, itemname: true });
        setOpen(true); setSeverity('warning'); setMessage('Please Enter a ItemName..!')
      }
    } else {
      setitem({ ...values, itemcode: '' })
      document.getElementById('itemCode').focus();
      setError({ ...error, itemcode: true });
      setOpen(true); setSeverity('warning'); setMessage('Please Enter a ItemCode..!')
    }
    return false;
  }

  const ItemTypeSave = () => {
    if (validate() === true) {
      let details = { itemName: values.itemname, itemCode: values.itemcode }
      BillingService.insertItem(details).then(res => {
        const message = res.data.message;
        if (message.toString(details) === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Insertion Failed');
        } refresh();
        getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }
  const ItemTypeUpdate = () => {
    if (validate() === true) {
      let details = { itemID: values.itemId, itemName: values.itemname, itemCode: values.itemcode }
      BillingService.updateItem(details).then(res => {
        const message = res.data.message;
        if (message.toString(details) === 'SUCCESS') {
          setOpen(true); setSeverity('success'); setMessage(message);
        } else {
          setOpen(true); setSeverity('error'); setMessage('Updation Failed');
        } refresh();
        getData();
      }).catch(error => {
        setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
      })
    }
  }

  const ItemTypeDelete = () => {
    setalertopen(true);
  }

  const refresh = () => {
    setPage(0)
    setItemTypeSaveDsa(false); setItemTypeUpdateDsa(true); setItemTypeDeleteDsa(true);
    setItemTypeSave(false); setItemTypeUpdate(false); setItemTypeDelete(false);
    setitem({ ...values, itemcode: '', itemname: '',itemId:'' });
    setError({ ...error, itemcode: false, itemname: false })
  }

  //icon
  const deleteicon = () => {
    return <DeleteOutlineRoundedIcon style={{color:'red'}}/>
  }
  //handleClose/open
  const handleClose = () => {
    setOpen(false);
  }
  //paginationCodes

  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  }
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  }
   //alertbox
   const [alertopen, setalertopen] = useState(false);

   const alertonClickOpen = (item) => {
     setitem({ ...values, itemId: item.itemId })
     setalertopen(true)
   }
 
   const alertNoOnClick = () => {
     refresh();
     setalertopen(false)
   }
 
   const alertYesOnClick = () => {
    BillingService.deleteItem(values.itemId).then((res) => {
      const message = res.data.message;
      if (message.toString() === 'SUCCESS') {
        setOpen(true); setSeverity('success'); setMessage('Delete Successfully');
      } else {
        setOpen(true); setSeverity('error'); setMessage('Failed To Delete');
      } refresh();
    }).catch(error => {
      setOpen(true); setSeverity('error'); setMessage(error.message); refresh();
    })
    setalertopen(false)
   }
   
  const navigate = useNavigate();
  const BackBotton =()=>{
    navigate('/Chargetype');
  }
  const ForwordBotton =()=>{
    navigate('/Billcharge');
  }
  return (
    <div>
      <Dialog open={alertopen}>
        <DialogTitle>
          <center style={{ fontFamily: 'Times New Roman'}}><h6>ARE YOU SURE,</h6></center>
          <h6 style={{ fontFamily: 'Times New Roman'}}>YOU WANT TO DELETE ?</h6>
          <Divider color="#FDA228" sx={{ height: 2 }} />
        </DialogTitle>
        <div className="form-inline p-1">
          <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px',fontFamily: 'Times New Roman' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
            <Button variant="success" className="p-1 mb-2 " style={{ fontFamily: 'Times New Roman',width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
        </div>
      </Dialog>
      <Home /><Snacbar open={open} message={message} severity={severity} onClose={handleClose} />
      <div style={{ paddingLeft: "80px" }}>
      <Row>
                    <Col xs={1}><ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small">
                        <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px', marginLeft: '5px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton></Col>
                    <Col xs={10}></Col>
                    <Col xs={1} style={{textAlign:'end'}}> <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small">
                        <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px', color: 'red', fontWeight: 'bold' }} /> </ToggleButton>
                    </Col>
                </Row>
        <ItemPap>
          <Grid container>
            <Grid xs={4} style={{ marginTop: "1rem" }}>
            <Row>
                <Col xs={1}>
          {/* <ToggleButton onClick={BackBotton} className='headerstyleStrt' size="small"> <ArrowBackIosIcon fontSize="small" style={{ fontSize: '16px',marginLeft:'5px' }} /> </ToggleButton> */}
            </Col>
            <Col xs={11}>
              <Typography color={"#0b64c5"} style={{ fontFamily: 'Times New Roman'}} fontWeight={"bolder"} variant={"h5"}>
                ItemType Details Entry
              </Typography><hr></hr>
              </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>Item Code</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={values.itemcode}
                    id='itemCode' onChange={itemcodehandlechange} isInvalid={error.itemcode} />
                </Col>
              </Row>
              <Row className="mt-3">
                <Col xs={4}>
                  <label style={mystyle1}>Item Name</label>
                </Col>
                <Col xs={8}>
                  <Form.Control size="sm" type="text" style={mystyle} value={values.itemname}
                    id='ItemName' onChange={itemnamehandlechange} isInvalid={error.itemname} />
                </Col>
              </Row>
              <Row className="mt-2">
                <Col lg={1}></Col>
                <Col lg={10}>
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="success" size="sm" disabled={itemTypeSaveDsa} onClick={ItemTypeSave}>
                    {itemTypeSave ? 'Processing..' : 'save'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="primary" size="sm" disabled={itemTypeUpdateDsa} onClick={ItemTypeUpdate}>
                    {itemTypeUpdate ? 'Processing..' : 'Update'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="danger" size="sm" disabled={itemTypeDeleteDsa} onClick={ItemTypeDelete}>
                    {itemTypeDelete ? 'Processing..' : 'Delete'}
                  </Button>
                  &nbsp;
                  <Button style={{ fontFamily: 'Times New Roman'}} variant="secondary" size="sm" onClick={refresh}>
                    Refresh
                  </Button>
                </Col>
                <Col lg={1}></Col>
              </Row>
            </Grid>

            <Grid xs={8} style={{ marginTop: "1rem" }}>
              <ItemPap1>
              <Row>
                  <Col xs={11}>
                <Typography color={"#0b64c5"} fontWeight={"bolder"} variant={"h5"}>
                  Existing  ItemType Details
                </Typography>
                </Col>
                <Col xs={1}>
                 {/* <ToggleButton onClick={ForwordBotton} className='headerstyleEND' size="small"> 
                <ArrowForwardIosIcon fontSize="small" style={{ fontSize: '16px'}} /></ToggleButton>  */}
                  </Col>
                </Row>
                <TableContainer sx={{ height: 360 }}  style={{ marginTop: "1px" }}>
                  <Table stickyHeader className="table table-bordered">
                    <TableHead>
                      <StyledTableRow>
                        <StyledTableCell style={{ width: "1rem" }}>SlNo</StyledTableCell>
                        <StyledTableCell>ChargeType Code</StyledTableCell>
                        <StyledTableCell>ChargeType Name</StyledTableCell>
                        <StyledTableCell style={{ textAlign: 'center' }}>Actions</StyledTableCell>
                      </StyledTableRow>
                    </TableHead>
                    <TableBody>
                      {Itemdetails.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                        .map((item, index) => (
                          <StyledTableRow hover key={item.serialNumber} onClick={() => editItemDetails(item)} >
                            <StyledTableCell style={{textAlign: 'center'}}>{item.serialNumber}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.itemCode}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}>{item.itemName}</StyledTableCell>
                            <StyledTableCell style={{textAlign: 'center'}}><lu onClick={() => alertonClickOpen(item)}>{deleteicon()}</lu></StyledTableCell>
                          </StyledTableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  showFirstButton
                  showLastButton
                  component='div'
                  count={Itemdetails.length}
                  rowsPerPage={rowsPerPage}
                  page={page}
                  onPageChange={handleChangePage}
                  onChangeRowsPerpage={handleChangeRowsPerPage}
                />
              </ItemPap1>
            </Grid>
          </Grid>
        </ItemPap>
      </div>
    </div>
  );
}

export default Itemtype;
